// Wholesale pricing formula based on purchase (cost) price.
//   1–23 pcs (base)    : +15%  (× 1.15)
//   24–48 pcs (tier 1)  : +12%  (× 1.12)
//   49+ pcs (tier 2)    : +10%  (× 1.10)
export const PRICE_TIERS = {
  base: { markup: 1.15, label: '1–23 pcs' },
  tier1: { qty: 24, markup: 1.12, label: '24–48 pcs' },
  tier2: { qty: 49, markup: 1.10, label: '49+ pcs' },
};

const round2 = (n) => Math.round(n * 100) / 100;

/**
 * Compute selling prices from a purchase (cost) price.
 * Returns { price, tier1: { qty, price }, tier2: { qty, price } }.
 */
export const computePrices = (purchasePrice) => {
  const cost = parseFloat(purchasePrice) || 0;
  return {
    price: round2(cost * PRICE_TIERS.base.markup),
    tier1: { qty: PRICE_TIERS.tier1.qty, price: round2(cost * PRICE_TIERS.tier1.markup) },
    tier2: { qty: PRICE_TIERS.tier2.qty, price: round2(cost * PRICE_TIERS.tier2.markup) },
  };
};
